export default __webpack_public_path__ + "static/media/checkmark.619d4a0b.svg";